export default "__VITE_ASSET__192cf116__"